module.exports = __webpack_public_path__ + "static/media/usergestion.99a75ec9.png";